var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-select',{staticClass:"supporting-layers-select elevation-2",staticStyle:{"min-width":"200px"},attrs:{"item-value":"title","item-text":"title","label":"Velg støttekartlag","menu-props":{
      closeOnContentClick: false,
      offsetY: true,
      disableKeys: false,
    },"items":_vm.mapLayers,"multiple":"","hide-details":"","outlined":"","filled":"","background-color":"white","small-chips":"","deletable-chips":"","dense":""},on:{"input":_vm.toggleLayerVisibility},model:{value:(_vm.activeLayers),callback:function ($$v) {_vm.activeLayers=$$v},expression:"activeLayers"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }